module.exports = __webpack_public_path__ + "img/product-ketang-qt-09.301f4d81.png";